
import { Container, Row, Col } from "react-bootstrap";
import logosClients from "../assets/img/allLogos.jpg";
import { ArrowRightCircle } from 'react-bootstrap-icons';
import 'animate.css';
import TrackVisibility from 'react-on-screen';

export const Address = () => {
 
  return (
    <section className="career" id="career">
      <Container>
        <Row className="aligh-items-center">
        <Col xs={12} md={6} xl={5}>
            <TrackVisibility>
              {({ isVisible }) =>
                <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                    <h3 className="chris">BRAND EXPERIENCE</h3>
                    <p>We are delighted and blessed to work with these happy clients. The testimonies above are confirmation that Totlesoft can work with you.</p><br />
                  <img src={logosClients} alt="Clients Logos Img"/>
                </div>}
            </TrackVisibility>
          </Col>

          <Col xs={12} md={6} xl={7}>
            <TrackVisibility>
              {({ isVisible }) =>
              <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                <button>Get In Touch Now! <ArrowRightCircle size={25} /></button><br />
                  <h6>Nigeria Office:</h6>
                  <p>Port Harcourt, Rivers State, 500102, Nigeria.</p><br />
                                    
                  <h6>+5 Locations Worldwide</h6><br />

                  <p>E-mail: totlesoft@gmail.com, info@totlesoft.com</p>
                 
                  <p>Mobile: +234(0)7064931387, +234(0)8163913697</p>
                  
                  <p className="chris"><a href="https://wa.me/2348163913697">WhatsApp</a></p><br />
 
                </div>}
            </TrackVisibility>
          </Col>
          
        </Row>
      </Container>
    </section>
  )
}
